export const TESTIMONIAL = [
  {
    name: "Arvind Maurya",
    image: "./assets/images/student/Arvind_Maurya.jpg",
    company: "C1 India Pvt Ltd, Gurgaon",
    college: "MCA from BHU",
    linkdin: "https://www.linkedin.com/in/arvindbhu/",
    quote: `It is a good place to get deep knowledge of the industry. I found a good experience of core java with an oops concept, along with I also get excellence knowledge of spring framework and web services.`,
  },
 
  {
    name: "Bhartendu kumar",
    image: "./assets/images/student/Bhartendu_kumar.jpg",
    company: "Diksha Technologies, Gurgaon, India",
    college: "MCA From GALGOTIAS UNIVERSITY",
    linkdin: "https://www.linkedin.com/in/bhartendu-kumar-103ba6101/",
    quote: `Given a very good training. Provided a latest Industry tools to work. Solving problem & providing guidance any time.`,
  },

  {
    name: "ASHWINI GUPTA",
    image: "./assets/images/student/Ashwini_Gupta.jpg",
    company: "Webkul Software Pvt Ltd. Noida",
    college: "MCA from BHU",
    linkdin: "https://www.linkedin.com/in/ashwini-kumar-gupta-804902110/",
    quote: ` I have passed mca from BHU 2016 batch. First of all I am telling, Thanks to Gateway to IT where I learned Java Tech, which help me to find the job in Webkul sector 63 noida, also in my co. i gave interview for PHP but good skills in java now i,m working on android tech. I have joined gateway to IT late time so there was no enough time for getting all skills of java, but sir work hard for teach me and also i am hard working for learn java to getting knowledge in minimum time. Sir have 12 year exp. and better guidance exp. that's provides us to getting good skills on JAVA Technology.`,
  },

  {
    name: "Ram Lakhan Yadav",
    image: "./assets/images/student/noImg.png",
    company: "BirlaSoft Noida",
    college: "MCA from SVSU",
    linkdin: "https://www.linkedin.com/in/ram-lakhan-yadav-605ba317b/",
    quote: `It was really a good experience with Gateway2IT. Excellent Training. Endless Learning Opportunities - if you show initiative.`,
  },

  {
    name: "Rahul Sinha",
    image: "./assets/images/student/Rahul_Sinha.jpg",
    company: "Sr. Java Developer at ScalePad",
    college: "MCA from BHU",
    linkdin: "https://www.linkedin.com/in/rahul-sinha-b3ab61117/",
    quote: `I think it is a best academy and coaching center to grow your knowledge from basic to best level. I really thankful to gateway2it.`,
  },
  
  {
    name: "Amir Ahmed",
    image: "./assets/images/student/Amir.jpg",
    company: "Tata Consultancy Services Gurgaon",
    college: "B.Tech from AIMT",
    linkdin: "https://www.linkedin.com/in/amirahmed3/",
    quote: `I learned a lot in your class because you took the extra time to explain things clearly. Thanks to Gateway2IT`,
  },

  {
    name: "RAHUL SINGH",
    image: "./assets/images/student/Rahul_Singh.jpg",
    company: "Manikaran Ldt. New Delhi",
    college: "B.Tech UPTU",
    linkdin: "https://www.linkedin.com/in/rahul-singh-33126495/",
    quote: `First of all, many thanks to Amit Sir for his support and believe on me. It is very good platform to enhance IT skills (specially java) for freshers and experienced and best for those who wants to grow rapidly in industry. I have learned a lot to things here.`,
  },

  {
    name: "Devesh Sharma",
    image: "./assets/images/student/Devesh.jpg",
    company: "HCL Technologies",
    college: "MCA from Indraprastha University",
    linkdin: "https://www.linkedin.com/in/devesh-sharma-7323018a/",
    quote: `It was a great learning experience. He taught java in depth both practically and theoretically. Also trained us on live project. Grew in confidence thereafter and was able to find a job as a software engineer in one of India's largest MNC.`,
  },

  {
    name: "Manoj Shaharavat",
    image: "./assets/images/student/Manoj_Saraswat.jpg",
    company: "Bharti Airtel",
    college: "MCA from BIT",
    linkdin: "https://www.linkedin.com/in/manoj-shaharavat-a3a87687/",
    quote: `It was really nice experienced for me to get in touch Gateway2IT, his way of teaching, way of updating students as per the companies expectation. I really was fully satisfied.`,
  },

  {
    name: "Jitendra Yadav",
    image: "./assets/images/student/Jitendra_Yadav.jpg",
    company: "Coforge (NIIT Technologies) Noida",
    college: "BCA from Microtek varanasi",
    linkdin: "https://www.linkedin.com/in/jitendrazeet/",
    quote: `It is a very good institute. It provides a platform where we can enhance & growth our career.`,
  },

  {
    name: "Vikram Singh",
    image: "./assets/images/student/Vikram_Singh.jpg",
    company: "Luqido ProIT Ghaziabad",
    college: "MCA from IGNOU",
    linkdin: "https://www.linkedin.com/in/vikramsinghjss/",
    quote: `I learned a lot in your class because you took the extra time to explain things clearly. Thanks Gateway2IT`,
  },
  {
    name: "Javed Khan",
    image: "./assets/images/student/Javed_Khan.jpg",
    company: "Espire InfoLabs",
    college: "MCA from AKTU",
    linkdin: "https://www.linkedin.com/in/javedanaa/",
    quote: `Providing a very good training. Provided a latest Industry tools to work. Solving problem & providing guidance any time. `,
  },

  {
    name: "Saurabh Singh",
    image: "./assets/images/student/Saurabh_Singh.jpg",
    company: "Manikaran Ltd. New Delhi",
    college: "B.Tech UPTU",
    linkdin: "https://www.linkedin.com/in/saurabh-singh-25b238142/",
    quote: `Given a very good training. Provided a latest Industry tools to work. Solving problem & providing guidance any time.`,
  },

  {
    name: "Ankit Verma",
    image: "./assets/images/student/Ankit_verma.jpg",
    company: "Ecubes Technologies, Lucknow",
    college: "MCA from AKTU",
    linkdin: "https://www.linkedin.com/in/djankit143/",
    quote: `I attend coaching at Gateway2IT. It is a very good institute. I done a project from this. Amit sir clears all concepts very well.`,
  },

  {
    name: "Shashi Sharma",
    image: "./assets/images/student/noImg.png",
    company: "HCL Technologies, Noida",
    college: "MCA from Delhi",
    linkdin: "https://www.linkedin.com/in/shashi-sharma-9a8a344a/",
    quote: `Real time knowledge and concepts are delivered nicely stuffed with industry conventions.`,
  },

  {
    name: "Arun Gaur",
    image: "./assets/images/student/Arun_Gaur.jpg",
    company: "Nkgsb Co-Operative Bank Ltd., Mumbai",
    college: "MCA from TMU",
    linkdin: "https://www.linkedin.com/in/arun-gaur-2080b695/",
    quote: `Excellent online class by Gateway2IT, and its on time and with flexible slots.`,
  },
 
];
